import { RequestHeaderModel } from './request-header.model';

/* eslint-disable @typescript-eslint/naming-convention */
export class RequestLineModel {
  id: number;
  request_header_id: number;
  line_no: number;
  request_type: string;
  request_type_id: number;
  request_type_name: string;
  request_type_description: string;
  type: string;
  no: number;
  name: string;
  description: string;
  menu_section_id: number;
  menu_section_name: string;
  menu_category_id: number;
  menu_category_name: string;
  menu_item_id: number;
  menu_item_name: string;
  quantity: number;
  unit_price: number;
  currency_code: string;
  amount: number;
  request_time: string;
  unit_of_measure: string;
  child_ages: string;
  note: string;

  constructor(
    index: number,
    header: RequestHeaderModel,
    type: string,
    name: string,
    typeName: string,
    description: string,
    quantity: number,
    unitPrice: number,
    currency: string,
    size: string,
    amount?:  any,
    requestOption?: string
  ) {
    this.id = 0;
    this.request_header_id = 0;
    this.line_no = index;
    this.request_type = header.type;
    this.request_type_id = header.menu_item_id;
    this.request_type_name = typeName;
    this.request_type_description = header.menu_section_name;
    this.type = type;
    this.no = this.menu_item_id;
    this.name = name;
    this.description = description;
    this.menu_section_id = header.menu_section_id;
    this.menu_section_name = header.menu_section_name;
    this.menu_category_id = header.menu_category_id;
    this.menu_category_name = header.menu_category_name;
    this.menu_item_id = header.menu_item_id;
    this.menu_item_name = header.menu_item_name;
    this.quantity = quantity;
    this.unit_price = unitPrice;
    this.currency_code = currency;
    this.amount = amount;
    this.request_time = requestOption || '';
    this.unit_of_measure = size;
    this.child_ages = null;
  }
}
